export enum AuthorisationGroupEnum {
  ProceedWithMinorRepairs = 0,
  SendToCleaningPartner = 1,
  ProceedWithDamageRisk = 2,
}
